import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"


import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./lslPDFTable";
import { drawSummary } from "./drawSummary";
import { drawGrandTotal } from "./drawGrandTotalpdf";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);

  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



  // ==========================
  // Summary Page
  // ==========================

  doc.addPage();

  drawHeader(doc, month, year, title);


  // Draw Grand Total row
  drawGrandTotal(doc, grandTotal);

  drawSummary(doc, summary, grandTotal);

  // ==========================
  // Footer on every page
  // ==========================

  drawFooter(doc, month, year, title);

   handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.SHOPNUMBER ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          highlyskilledtime: 0,
          highlyskilledcost: 0,
          skilledtime: 0,
          skilledcost: 0,
          semiskilledtime: 0,
          semiskilledcost: 0,
          unskilledtime: 0,
          unskilledcost: 0,
          oncostlabour: 0,
          oncoststore: 0,

        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.highlyskilledtime += Number(row.HIGHLYSKILLEDTIME || 0);
    groups[shop].total.highlyskilledcost += Number(row.HIGHLYSKILLEDCOST || 0);
    groups[shop].total.skilledtime += Number(row.SKILLEDTIME || 0);
    groups[shop].total.skilledcost += Number(row.SKILLEDCOST || 0);
    groups[shop].total.semiskilledtime += Number(row.SEMISKILLEDTIME || 0);
    groups[shop].total.semiskilledcost += Number(row.SEMISKILLEDCOST || 0);
    groups[shop].total.unskilledtime += Number(row.UNSKILLEDTIME || 0);
    groups[shop].total.unskilledcost += Number(row.UNSKILLEDCOST || 0);
    groups[shop].total.oncostlabour += Number(row.ONCOSTLABOUR || 0);
    groups[shop].total.oncoststore += Number(row.ONCOSTSTORE || 0);





    return groups;
  }, {});
}